import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, useHistory, Switch } from 'react-router-dom';
import { ADS, HOME_PAGE, LANDING_PAGE, LOGIN, CTKMJ2K } from 'global/routes';
import { Provider } from 'react-redux';
import { ProgressTurn } from 'components';
import LocaleProvider from './utils/providers/LocaleProvider';
import { useStore } from 'store';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.css';
import 'react-multi-carousel/lib/styles.css';
import 'swiper/css/swiper.css';
import MainPage from 'pages/MainPage/MainPage';
import TagManager from 'react-gtm-module';
import Login3G from 'pages/Login3G/Login3G';
import Ads from 'pages/Ads/Ads';
import LandingPage from 'pages/LandingPage/LandingPage';
import CTKMj2k from 'pages/CTKMJ2K/CTKMj2k';

const GTM_ID = 'GTM-NHZ977Z';

function ScrollToTop() {
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [history.location.pathname]);

  return (null);
}

const App = () => {
  const store = useStore();

  useEffect(() => {
    TagManager.initialize({ gtmId: GTM_ID });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Provider store={store}>
        <LocaleProvider>
          <ProgressTurn />
          <Switch>
            <Route
              path={ADS}
              component={Ads}
            />
            <Route
              path={LOGIN}
              component={Login3G}
            />
            <Route
              path={LANDING_PAGE}
              exact
              component={LandingPage}
            />
            <Route
              path={CTKMJ2K}
              // exact
              component={CTKMj2k}
            />
            <Route
              path={HOME_PAGE}
              component={MainPage}
            />
          </Switch>
        </LocaleProvider>
      </Provider>
    </Router>
  )
}

export default App;
